module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/icon-payment-lg-4d22e915256016187f68387f96681d28.png";